/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: "intense" | "mild" | "moderate" | "none" }} Today_Checkin_LevelInputs */

const en_us2_today_checkin_level = /** @type {(inputs: Today_Checkin_LevelInputs) => LocalizedString} */ (i) => {
	if (i?.level === "none") return /** @type {LocalizedString} */ (`None`);
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Mild`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Moderate`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Intense`);
	return /** @type {LocalizedString} */ ("today.checkin_level");
};

const pt_br2_today_checkin_level = /** @type {(inputs: Today_Checkin_LevelInputs) => LocalizedString} */ (i) => {
	if (i?.level === "none") return /** @type {LocalizedString} */ (`Nenhuma`);
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Leve`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Moderada`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Intensa`);
	return /** @type {LocalizedString} */ ("today.checkin_level");
};

const es_419_today_checkin_level = /** @type {(inputs: Today_Checkin_LevelInputs) => LocalizedString} */ (i) => {
	if (i?.level === "none") return /** @type {LocalizedString} */ (`Ninguno`);
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Leve`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Moderado`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Intenso`);
	return /** @type {LocalizedString} */ ("today.checkin_level");
};

const pt_pt2_today_checkin_level = /** @type {(inputs: Today_Checkin_LevelInputs) => LocalizedString} */ (i) => {
	if (i?.level === "none") return /** @type {LocalizedString} */ (`Nenhuma`);
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Ligeira`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Moderada`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Intensa`);
	return /** @type {LocalizedString} */ ("today.checkin_level");
};

const fr_fr2_today_checkin_level = /** @type {(inputs: Today_Checkin_LevelInputs) => LocalizedString} */ (i) => {
	if (i?.level === "none") return /** @type {LocalizedString} */ (`Aucune`);
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Légères`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Modérées`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Intenses`);
	return /** @type {LocalizedString} */ ("today.checkin_level");
};

const de_de2_today_checkin_level = /** @type {(inputs: Today_Checkin_LevelInputs) => LocalizedString} */ (i) => {
	if (i?.level === "none") return /** @type {LocalizedString} */ (`Keiner`);
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Leicht`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Mittel`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Stark`);
	return /** @type {LocalizedString} */ ("today.checkin_level");
};

const it_it2_today_checkin_level = /** @type {(inputs: Today_Checkin_LevelInputs) => LocalizedString} */ (i) => {
	if (i?.level === "none") return /** @type {LocalizedString} */ (`Nessuno`);
	if (i?.level === "mild") return /** @type {LocalizedString} */ (`Lieve`);
	if (i?.level === "moderate") return /** @type {LocalizedString} */ (`Moderato`);
	if (i?.level === "intense") return /** @type {LocalizedString} */ (`Intenso`);
	return /** @type {LocalizedString} */ ("today.checkin_level");
};

/**
* | level | output |
* | --- | --- |
* | "none" | "None" |
* | "mild" | "Mild" |
* | "moderate" | "Moderate" |
* | "intense" | "Intense" |
*
* @param {Today_Checkin_LevelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_level = /** @type {((inputs: Today_Checkin_LevelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_LevelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_level(inputs)
	if (locale === "es-419") return es_419_today_checkin_level(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_level(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_level(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_level(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_level(inputs)
	return en_us2_today_checkin_level(inputs)
});
export { today_checkin_level as "today.checkin_level" }